/* State of an offer request (UI term: Serienanfrage) as shown to the customer. */
export enum OfferRequestState {
	Unknown = 0,
	/** Submitted by the customer, not yet picked up by Blexon. */
	Submitted = 1,
	/** Blexon is currently reviewing and calculating the request. */
	InReview = 2,
	/** An individual offer is available for the customer. */
	OfferAvailable = 3,
	/** The customer accepted the individual offer. */
	Accepted = 4,
	/** Blexon cannot make an offer for this request. */
	Declined = 5,
	/** The offer expired without being accepted. */
	Expired = 6,
}
